module.exports = __webpack_public_path__ + "static/img/product_architecture.540ac61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_architecture.jpg
// module id = +BEK
// module chunks = 0